import React from 'react';
import { FormattedMessage } from 'react-intl';
import { appNotification } from '../../containers/App/appNotification';
import { createLocalNotification } from '../../containers/App/utils';

const notification = createLocalNotification('OptionList', {
    error: (
        <FormattedMessage
            id='front-app/OptionList/Notification/Error:title'
            defaultMessage='Option List Error'
        />
    ),
});

export const optionListNotifications = {
    unknownError: (details?: JSX.Element | string) => (
        notification.error(appNotification.texts.unknownError(details))
    ),
};
